// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"506":"3b1d3aa2","746":"a2f054d5"}[chunkId] + ".css";
};